import {
  canAccessAssignmentSubmitPage,
  canAccessAssignmentSummaryPage,
  canCreateAssignment,
  canEnlargeOpenDiscussionAnswer,
  canManageViewMode,
  canPrefillCorrectAnswers,
  canPrefillEvaluation,
  canReadAssignmentNotes,
  canReadDraftFeedbackForAssignment,
  canReadDraftNoteToTeacher,
  canReadQuestionGrade,
  canReadQuestionStatus,
  canReadSatisfactionScore,
  canReadSavedState,
  canReadStudentAssignedMode,
  canReadStudentLearningViewMode,
  canReadStudentTestViewMode,
  canReadTeacherSolvedMode,
  canReadSubmissionHistory,
  canRevealAnswers,
  canSeeCanvas,
  canSeeFeedback,
  canSeePresenterActionBar,
  canSeeQuestionCheckButton,
  canSeeQuestionEvaluation,
  canSeeQuestionHintButton,
  canSeeQuestionResetButton,
  canSeeQuestionScoreWeight,
  canSeeQuestionShowAnswerButton,
  canSeeReturnToFixSwitch,
  canSeeSatisfactionSurvey,
  canSeeSlidesNavigation,
  canSeeUnansweredQuestions,
  canSubmitAssignment,
  canSubmitFeedbackForAssignment,
  canUpdateLocalState,
  canUpdateSavedState,
  canUpsertDraftFeedbackForAssignment,
  canSeePlenaryLessonCode,
  canUpsertDraftNoteToTeacher,
  canUpsertQuestionGrade,
  canUpsertSatisfactionScore
} from './rules';
import { AuthorizationModuleClientType } from '../../../types';

export const AuthorizationModuleCoreClient: AuthorizationModuleClientType = {
  canAccessAssignmentSubmitPage,
  canAccessAssignmentSummaryPage,
  canCreateAssignment,
  canEnlargeOpenDiscussionAnswer,
  canManageViewMode,
  canPrefillCorrectAnswers,
  canPrefillEvaluation,
  canReadAssignmentNotes,
  canReadDraftFeedbackForAssignment,
  canReadDraftNoteToTeacher,
  canReadQuestionGrade,
  canReadQuestionStatus,
  canReadSatisfactionScore,
  canReadSavedState,
  canReadStudentAssignedMode,
  canReadStudentLearningViewMode,
  canReadStudentTestViewMode,
  canReadTeacherSolvedMode,
  canReadSubmissionHistory,
  canRevealAnswers,
  canSeeCanvas,
  canSeeFeedback,
  canSeePlenaryLessonCode,
  canSeePresenterActionBar,
  canSeeQuestionCheckButton,
  canSeeQuestionEvaluation,
  canSeeQuestionHintButton,
  canSeeQuestionResetButton,
  canSeeQuestionScoreWeight,
  canSeeQuestionShowAnswerButton,
  canSeeReturnToFixSwitch,
  canSeeSatisfactionSurvey,
  canSeeSlidesNavigation,
  canSeeUnansweredQuestions,
  canSubmitAssignment,
  canSubmitFeedbackForAssignment,
  canUpdateLocalState,
  canUpdateSavedState,
  canUpsertDraftFeedbackForAssignment,
  canUpsertDraftNoteToTeacher,
  canUpsertQuestionGrade,
  canUpsertSatisfactionScore
};
